export default __webpack_public_path__ + "static/media/grocery-cart.3e449c47.jpg";